export function formatToJSON(text) {
  return JSON.parse(text);
}

export const createEmptyRichText = () => [
  { type: "paragraph", children: [{ text: "" }] },
];

export function parseRichText(value) {
  if (!value) return createEmptyRichText();

  try {
    const parsed = JSON.parse(value);

    if (Array.isArray(parsed) && parsed.length > 0) return parsed;
  } catch (error) {}

  return [{ type: "paragraph", children: [{ text: String(value) }] }];
}
